import { isAnalyticsCookieAccepted } from "@/shared/functions/functions";
import TagManager from "@sooro-io/react-gtm-module";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Pushes an event to the GTM dataLayer, but only if the user
 * has accepted the analytics cookie. Use this instead of calling
 * TagManager.dataLayer() directly anywhere in the app.
 */
export const pushDataLayerEvent = (
  data: Record<string, unknown>,
  cookieConsentStatus: string
) => {
  if (!isAnalyticsCookieAccepted(cookieConsentStatus)) return;

  TagManager.dataLayer({ dataLayer: data });
};

/**
 * Call this when the user accepts the analytics cookie to update
 * Consent Mode so gated GTM/GA4 tags are allowed to fire.
 */
export const grantAnalyticsConsent = () => {
  window.gtag?.("consent", "update", {
    analytics_storage: "granted"
  });
};

/**
 * Call this if the user later revokes/denies analytics consent.
 */
export const revokeAnalyticsConsent = () => {
  window.gtag?.("consent", "update", {
    analytics_storage: "denied"
  });
};
